import React from "react";
import { makeStyles } from "@mui/styles";
import { HeaderMenu } from "../components/Header";
import { MobileWeb } from "../components/mobile/BreakPoint";
import { Theme } from "@mui/material";
import { Footer } from "../components/Footer";
import { MobileFooter } from "../components/mobile/MobileFooter";
import { Typography } from "../components/Typography";
import fin_img1 from "../asset/fin_manage1.png";
import fin_img2 from "../asset/fin_manage2.png";
import fin_img3 from "../asset/fin_manage3.png";
import fin_img4 from "../asset/fin_manage4.png";
import fin_img5 from "../asset/fin_manage5.png";
import fin_img6 from "../asset/fin_manage6.png";
import fin_img7 from "../asset/fin_manage7.png";
import fin_img8 from "../asset/fin_manage8.png";
import fin_img9 from "../asset/fin_manage9.png";
import fin_img10 from "../asset/fin_manage10.png";
import fin_img11 from "../asset/fin_manage11.png";
import fin_img12 from "../asset/fin_manage12.png";
import half_circle from "../asset/half_circle.png";
import E_lean1 from "../asset/E_lean1.png";
import E_lean2 from "../asset/E_lean2.png";
import E_lean3 from "../asset/E_lean3.png";
import E_lean4 from "../asset/E_lean4.png";
import S_simul1 from "../asset/S_simul1.png";
import S_simul2 from "../asset/S_simul2.png";
import S_simul3 from "../asset/S_simul3.png";
import S_simul4 from "../asset/S_simul4.png";
import E_exec1 from "../asset/E_exec1.png";
import E_exec2 from "../asset/E_exec2.png";
import E_exec3 from "../asset/E_exec3.png";
import E_exec4 from "../asset/E_exec4.png";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import MobileSliderMBA1 from "../components/mobile/MobileSlider_MBA1";
import MobileSliderMBA2 from "../components/mobile/MobileSlider_MBA2";
import MobileSliderMBA5 from "../components/mobile/MobileSlider_MBA5";
import MobileSliderMBA4 from "../components/mobile/MobileSlider_MBA4";
import MobileSliderMBA3 from "../components/mobile/MobileSlider_MBA3";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "20px auto",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      margin: "0px",
      height: "auto",
    },
  },
  body: {
    width: "100%",
    alignSelf: "center",
    borderTop: "1px solid #0000003b",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "flex",
      flexDirection: "column",
      width: "auto",
      margin: "12px 10px",
      borderTop: "none",
    },
  },
  container1: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    marginTop: 50,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      flexDirection: "column",
    },
  },
  top_text: {
    position: "relative",
    display: "flex",
    justifyContent: "left",
    color: "#EB4FE5",
    marginTop: "90px",
    marginBottom: "50px",
    maxWidth: 1290,
    fontSize: "3rem",
  },

  conBox: {
    height: 200,
    display: "flex",
    alignSelf: "center",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "none",
    },
  },
  conBox2: {
    display: "flex",
    flexDirection: "column",
    alignSelf: "center",
    width: "100%",
    height: 360,
    background: "#fdf5fd",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "none",
    },
  },
  conBox3: {
    display: "flex",
    flexDirection: "column",
    alignSelf: "center",
    alignItems: "center",
    width: "100%",
    position: "relative",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      width: "100%",
    },
  },
  conBox4: {
    display: "flex",
    alignSelf: "center",
    "&>div": {
      marginRight: 20,
      "&:last-child": {
        marginRight: 0,
      },
    },
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      flexDirection: "column",
      "&>div": {
        marginRight: 0,
        marginBottom: 25,
      },
    },
  },
  pinkConBox1: {
    display: "flex",
    alignSelf: "center",
    marginBottom: 30,
    "&>div": {
      marginRight: 20,
      "&:last-child": {
        marginRight: 0,
      },
    },
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      flexDirection: "column",
      "&>div": {
        marginRight: 0,
        marginBottom: 25,
      },
    },
  },
  pinkConBox2: {
    display: "flex",
    alignSelf: "center",
    marginBottom: 30,
    "&>div": {
      marginRight: 20,
      "&:last-child": {
        marginRight: 0,
      },
    },
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      flexDirection: "column",
      "&>div": {
        marginRight: 0,
        marginBottom: 25,
      },
    },
  },
  pinkConBox3: {
    display: "flex",
    alignSelf: "center",
    marginBottom: 50,
    "&>div": {
      marginRight: 20,
      "&:last-child": {
        marginRight: 0,
      },
    },
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      flexDirection: "column",
      "&>div": {
        marginRight: 0,
        marginBottom: 25,
      },
    },
  },

  conBoxT: {
    display: "flex",
    alignSelf: "center",
  },
  suns: {
    display: "flex",
    alignItems: "baseline",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      marginRight: "20px",
      fontSize: "10px",
    },
  },
  conSubBox1: {
    width: 80,
    height: 23,
    background: "#eb5fe5",
    borderRadius: 20,
    position: "relative",
    top: 13,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  conSubBoxSUNS: {
    width: "80%",
    height: 23,
    background: "#eb5fe5",
    borderRadius: 20,
    position: "relative",
    top: 13,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  conSubBoxSUNS2: {
    width: 240,
    height: 100,
    textAlign: "center",
    alignItems: "center",
    fontSize: 12,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    border: "1px solid #eb5fe5",
    borderRadius: 20,
    padding: "0px 5px",
  },
  conSubBox2: {
    height: 51,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  conSubBox3: {
    width: 170,
    height: 110,
    textAlign: "center",
    alignItems: "center",
    fontSize: 12,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    border: "1px solid #eb5fe5",
    borderRadius: 20,
    padding: "0px 5px",
  },
  conSubBox4: {
    width: 230,
    height: 35,
    textAlign: "center",
    border: "1px solid #E4F4FF",
    fontSize: 12,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  conSubBox5: {
    width: 230,
    height: 50,
    textAlign: "center",
    border: "1px solid #E4F4FF",
    fontSize: 12,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  conSubBox6: {
    width: 395,
    textAlign: "center",
    border: "1px solid #eb5fe5",
    fontSize: 10,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      width: "99%",
    },
  },
  conImgBox: {
    display: "flex",
    alignItems: "center",
    marginBottom: 25,
  },
  textlist1: {
    textAlign: "left",
    display: "block",
    alignSelf: "center",
  },
  textlist2: {
    textAlign: "left",
    display: "block",
    alignSelf: "center",
    fontSize: 10,
  },
  textlist_E: {
    textAlign: "left",
    alignSelf: "center",
    display: "flex",
    flexDirection: "row",
    padding: "5px 0px",
    lineHeight: "20px",
    width: 350,
    height: "115px",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      fontSize: "11px",
      height: "135px",
    },
  },
  textlist_S: {
    textAlign: "left",
    alignSelf: "center",
    padding: "5px 0px",
    lineHeight: "20px",
    height: "80px",
    alignItems: "center",
  },
  pinkT: {
    fontSize: 60,
    fontWeight: 600,
    lineHeight: "72px",
    color: "#EB5FE5",
  },
  mobileSlider: {
    display: "none",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      display: "block",
      width: "100%",
      textAlign: "-webkit-center",
      marginTop: "20px",
      background: "#fdf5fd",
      height: 275,
    },
  },
  textBox1: {
    alignSelf: "center",
    position: "relative",
    width: 800,
    height: 44,
    background: "#eb5fe5",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 20,
    marginBottom: 15,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      width: "100%",
      maxWidth: 824,
    },
  },
  mText: {
    fontSize: "20px",
    fontWeight: 500,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      fontSize: "14px",
    },
  },
  smallPinkBox: {
    display: "flex",
    position: "relative",
    flexDirection: "column",
    alignItems: "center",
  },
}));

const MbaContentPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HeaderMenu />
      <div className={classes.body}>
        <div className={classes.container1}>
          <div className={classes.textBox1}>
            <span className={classes.mText}>
              1. 간호사를 위한 알기 쉬운 재무관리 교육 콘텐츠
            </span>
          </div>
          {/* Small Pink Box start */}
          <div className={classes.pinkConBox1}>
            <div className={classes.smallPinkBox}>
              <div className={classes.conSubBox1}>
                <Typography
                  variant="mbaContent"
                  style={{ color: "#fff", fontWeight: 600 }}
                >
                  Part1
                </Typography>
              </div>

              <div className={classes.conSubBox3}>
                <div style={{ textAlign: "left" }}>
                  <Typography
                    variant="mbaContent"
                    style={{ color: "#eb5fe5", fontWeight: 600 }}
                  >
                    재무관리 이해
                  </Typography>
                  <div className={classes.textlist1}>
                    <li>재무관리의 필요성</li>
                    <li>재무회계 기초</li>
                  </div>
                </div>
              </div>
            </div>

            <div className={classes.smallPinkBox}>
              <div className={classes.conSubBox1}>
                <Typography
                  variant="mbaContent"
                  style={{ color: "#fff", fontWeight: 600 }}
                >
                  Part2
                </Typography>
              </div>
              <div className={classes.conSubBox3}>
                <div style={{ textAlign: "left" }}>
                  <Typography
                    variant="mbaContent"
                    style={{ color: "#eb5fe5", fontWeight: 600 }}
                  >
                    재무재표 분석
                  </Typography>
                  <div className={classes.textlist1}>
                    <li>대차대조표 따라잡기</li>
                    <li>손익계산서 따라잡기</li>
                  </div>
                </div>
              </div>
            </div>

            <div className={classes.smallPinkBox}>
              <div className={classes.conSubBox1}>
                <Typography
                  variant="mbaContent"
                  style={{ color: "#fff", fontWeight: 600 }}
                >
                  Part3
                </Typography>
              </div>

              <div className={classes.conSubBox3}>
                <div style={{ textAlign: "left" }}>
                  <Typography
                    variant="mbaContent"
                    style={{ color: "#eb5fe5", fontWeight: 600 }}
                  >
                    재무비율 활용
                  </Typography>
                  <div className={classes.textlist1}>
                    <li>재무비율 분석과 활용</li>
                    <li>실전 재무비율 사례분석</li>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Small Pink Box End */}

          <div className={classes.conBox2}>
            <div style={{ width: 625, marginBottom: 10 }}>
              <Typography variant="mbaContent">콘텐츠 구성</Typography>
            </div>

            <div className={classes.conImgBox}>
              <img src={fin_img1} alt="fin_manage1"></img>
              <PlayArrowIcon />
              <img src={fin_img2} alt="fin_manage2"></img>
              <PlayArrowIcon />
              <img src={fin_img3} alt="fin_manage3"></img>
            </div>
            <div className={classes.conImgBox}>
              <img src={fin_img4} alt="fin_manage4"></img>
              <PlayArrowIcon />
              <img src={fin_img5} alt="fin_manage5"></img>
              <PlayArrowIcon />
              <img src={fin_img6} alt="fin_manage6"></img>
            </div>
          </div>
          {/* 슬라이드 */}
          <div className={classes.mobileSlider}>
            <Typography variant="mbaContent" style={{ marginBottom: 10 }}>
              콘텐츠 구성
            </Typography>
            <MobileSliderMBA1 />
          </div>
        </div>

        {/* (2) */}

        <div className={classes.container1}>
          <div className={classes.textBox1}>
            <span className={classes.mText}>
              2. 간호사를 위한 알기 쉬운 재무관리 교육 콘텐츠
            </span>
          </div>

          {/* Small Pink Box start */}
          <div className={classes.pinkConBox2}>
            <div className={classes.smallPinkBox}>
              <div className={classes.conSubBox1}>
                <Typography
                  variant="mbaContent"
                  style={{ color: "#fff", fontWeight: 600 }}
                >
                  Part1
                </Typography>
              </div>

              <div className={classes.conSubBox3}>
                <div style={{ textAlign: "left" }}>
                  <Typography
                    variant="mbaContent"
                    style={{ color: "#eb5fe5", fontWeight: 600 }}
                  >
                    원가 이해
                  </Typography>
                  <div className={classes.textlist2}>
                    <li>원가회계의 기초</li>
                    <li>원가의 개념과 목적</li>
                  </div>
                </div>
              </div>
            </div>

            <div className={classes.smallPinkBox}>
              <div className={classes.conSubBox1}>
                <Typography
                  variant="mbaContent"
                  style={{ color: "#fff", fontWeight: 600 }}
                >
                  Part2
                </Typography>
              </div>
              <div className={classes.conSubBox3}>
                <div style={{ textAlign: "left" }}>
                  <Typography
                    variant="mbaContent"
                    style={{ color: "#eb5fe5", fontWeight: 600 }}
                  >
                    원가 계산
                  </Typography>
                  <div className={classes.textlist2}>
                    <li>병원 원가 계산</li>
                    <li>원가 계산 방법</li>
                  </div>
                </div>
              </div>
            </div>

            <div className={classes.smallPinkBox}>
              <div className={classes.conSubBox1}>
                <Typography
                  variant="mbaContent"
                  style={{ color: "#fff", fontWeight: 600 }}
                >
                  Part3
                </Typography>
              </div>

              <div className={classes.conSubBox3}>
                <div style={{ textAlign: "left" }}>
                  <Typography
                    variant="mbaContent"
                    style={{ color: "#eb5fe5", fontWeight: 600 }}
                  >
                    원가 분석
                  </Typography>
                  <div className={classes.textlist2}>
                    <li>활동기준 원가 계산</li>
                    <li>시간동인 활동 기준 원가 계산</li>
                  </div>
                </div>
              </div>
            </div>

            <div className={classes.smallPinkBox}>
              <div className={classes.conSubBox1}>
                <Typography
                  variant="mbaContent"
                  style={{ color: "#fff", fontWeight: 600 }}
                >
                  Part4
                </Typography>
              </div>

              <div className={classes.conSubBox3}>
                <div style={{ textAlign: "left" }}>
                  <Typography
                    variant="mbaContent"
                    style={{ color: "#eb5fe5", fontWeight: 600 }}
                  >
                    원가 활용
                  </Typography>
                  <div className={classes.textlist2}>
                    <li>원가 계산 시뮬레이션</li>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Small Pink Box End */}

          <div className={classes.conBox2}>
            <div style={{ width: 625, marginBottom: 10 }}>
              <Typography variant="mbaContent">콘텐츠 구성</Typography>
            </div>

            <div className={classes.conImgBox}>
              <img src={fin_img7} alt="fin_manage7"></img>
              <PlayArrowIcon />
              <img src={fin_img8} alt="fin_manage8"></img>
              <PlayArrowIcon />
              <img src={fin_img9} alt="fin_manage9"></img>
            </div>
            <div className={classes.conImgBox}>
              <img src={fin_img10} alt="fin_manage10"></img>
              <PlayArrowIcon />
              <img src={fin_img11} alt="fin_manage11"></img>
              <PlayArrowIcon />
              <img src={fin_img12} alt="fin_manage12"></img>
            </div>
          </div>
          <div className={classes.mobileSlider}>
            <Typography variant="mbaContent" style={{ marginBottom: 10 }}>
              콘텐츠 구성
            </Typography>
            <MobileSliderMBA2 />
          </div>
        </div>

        {/* (3) */}

        <div className={classes.container1}>
          <div className={classes.textBox1}>
            <span className={classes.mText}>
              3. 간호사를 위한 알기 쉬운 창업관리 교육 콘텐츠 (SUNS)
            </span>
          </div>
          {/* Small Pink Box start */}
          <div className={classes.pinkConBox3}>
            <div className={classes.smallPinkBox}>
              <div className={classes.conSubBoxSUNS}>
                <Typography
                  variant="mbaContent"
                  style={{ color: "#fff", fontWeight: 600 }}
                >
                  1. E-LEARNING PHASE
                </Typography>
              </div>

              <div className={classes.conSubBoxSUNS2}>
                <div style={{ textAlign: "left" }}>
                  <Typography
                    variant="mbaContent"
                    style={{ color: "#eb5fe5", fontWeight: 600 }}
                  ></Typography>
                  <div className={classes.textlist1}>
                    <Typography variant="mbaContent" style={{ fontSize: 11 }}>
                      간호창업에 요구되는 이론과 지식 학습
                    </Typography>
                  </div>
                </div>
              </div>
            </div>

            <div className={classes.smallPinkBox}>
              <div className={classes.conSubBoxSUNS}>
                <Typography
                  variant="mbaContent"
                  style={{ color: "#fff", fontWeight: 600 }}
                >
                  2. E-SUMULATION PHASE
                </Typography>
              </div>
              <div className={classes.conSubBoxSUNS2}>
                <div style={{ textAlign: "left" }}>
                  <Typography
                    variant="mbaContent"
                    style={{ color: "#eb5fe5", fontWeight: 600 }}
                  ></Typography>
                  <div className={classes.textlist1} style={{ width: 160 }}>
                    <Typography variant="mbaContent" style={{ fontSize: 11 }}>
                      간호 창업 경영 시나리오 사례에 경영 의사결정 시뮬레이션
                      학습
                    </Typography>
                  </div>
                </div>
              </div>
            </div>

            <div className={classes.smallPinkBox}>
              <div className={classes.conSubBoxSUNS}>
                <Typography
                  variant="mbaContent"
                  style={{ color: "#fff", fontWeight: 600 }}
                >
                  3. E-EXECUTIVES PHASE
                </Typography>
              </div>

              <div className={classes.conSubBoxSUNS2}>
                <div style={{ textAlign: "left" }}>
                  <Typography
                    variant="mbaContent"
                    style={{ color: "#eb5fe5", fontWeight: 600 }}
                  ></Typography>
                  <div className={classes.textlist1}>
                    <Typography variant="mbaContent" style={{ fontSize: 11 }}>
                      간호창업 분야의 모의 창업계획서를 작성
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Small Pink Box End */}
          <div className={classes.conBoxT}>
            <div className={classes.suns}>
              <span className={classes.pinkT}>S</span>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontWeight: 600,
                  color: "#9e9e9e",
                }}
              >
                tart
              </span>
            </div>
            <div className={classes.suns}>
              <span className={classes.pinkT}>U</span>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontWeight: 600,
                  color: "#9e9e9e",
                }}
              >
                p
              </span>
            </div>
            <div className={classes.suns}>
              <span className={classes.pinkT}>N</span>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontWeight: 600,
                  color: "#9e9e9e",
                }}
              >
                urses
              </span>
            </div>
            <div className={classes.suns}>
              <span className={classes.pinkT}>S</span>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontWeight: 600,
                  color: "#9e9e9e",
                }}
              >
                tart
              </span>
            </div>
          </div>
        </div>
        {/* (3-1) */}
        <div className={classes.container1}>
          <div className={classes.conBox3} style={{ alignItems: "center" }}>
            <div style={{ display: "contents" }}>
              <img
                src={half_circle}
                style={{
                  width: "193px",
                  height: "96px",
                  position: "relative",
                  top: 30,
                }}
                alt="halfCircle"
              ></img>
              <Typography
                variant="H6"
                style={{ top: "-10px", position: "relative", color: "#EB5FE5" }}
              >
                E-learning
              </Typography>
            </div>
            <div
              style={{
                width: "100%",
                height: 500,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                background: "#fdf5fd",
              }}
            >
              <div className={classes.conBox4}>
                <div>
                  <div
                    className={classes.conSubBox6}
                    style={{
                      borderRadius: "20px 20px 0px 0px",
                      background: "#eb5fe5",
                    }}
                  >
                    <Typography variant="mbaContent" style={{ color: "#fff" }}>
                      교육 콘텐츠 내용
                    </Typography>
                  </div>
                  <div
                    className={classes.conSubBox6}
                    style={{ padding: "5px 0px", height: "115px" }}
                  >
                    <div className={classes.textlist1}>
                      <span style={{ lineHeight: "20px" }}>창업의 이해</span>
                      <br />
                      <span style={{ lineHeight: "20px" }}>
                        간호와 기업가 정신
                      </span>
                      <br />
                      <span style={{ lineHeight: "20px" }}>
                        간호창업과 경영전략
                      </span>
                      <br />
                      <span style={{ lineHeight: "20px" }}>
                        간호창업과 재문관리
                      </span>
                      <br />
                      <span style={{ lineHeight: "20px" }}>간호창업 실전</span>
                    </div>
                  </div>
                </div>
                <div>
                  <div
                    className={classes.conSubBox6}
                    style={{
                      borderRadius: "20px 20px 0px 0px",
                      background: "#eb5fe5",
                    }}
                  >
                    <Typography variant="mbaContent" style={{ color: "#fff" }}>
                      교육 콘텐츠 구성
                    </Typography>
                  </div>
                  <div className={classes.conSubBox6}>
                    <div className={classes.textlist_E}>
                      <div style={{ marginRight: "50px" }}>
                        <li>들어가기</li>
                        <li>학습내용 Part 1</li>
                        <li>학습내용 Part 2</li>
                        <li>단원정리</li>
                      </div>
                      <div>
                        <li>학습목표</li>
                        <li>Quiz</li>
                        <li>요약하기</li>
                        <li>단원정리 퀴즈</li>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={classes.conBox}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={E_lean1}
                    alt="img_E_lean1"
                    style={{ marginRight: "10px" }}
                  ></img>
                  <img
                    src={E_lean2}
                    alt="img_E_lean2"
                    style={{ marginRight: "10px" }}
                  ></img>
                  {/* PINK 화살표 vector */}
                  <div
                    style={{
                      borderTop: "17px solid transparent",
                      borderRight: "0px solid transparent",
                      borderBottom: "17px solid transparent",
                      borderLeft: "13px solid #eb5fe5",
                      position: "relative",
                      marginRight: 7,
                    }}
                  />
                  {/* PINK 화살표 vector */}
                  <img
                    src={E_lean3}
                    alt="img_E_lean3"
                    style={{ marginRight: "10px" }}
                  ></img>
                  <img src={E_lean4} alt="img_E_lean4"></img>
                </div>
              </div>
            </div>
            {/* 슬라이드 */}
            <div className={classes.mobileSlider} style={{ marginBottom: 25 }}>
              <Typography variant="mbaContent" style={{ marginBottom: 10 }}>
                콘텐츠 구성
              </Typography>
              <MobileSliderMBA3 />
            </div>
          </div>
        </div>

        {/* (3-2) */}
        <div className={classes.container1}>
          <div className={classes.conBox3} style={{ alignItems: "center" }}>
            <div style={{ display: "contents" }}>
              <img
                src={half_circle}
                style={{
                  width: "193px",
                  height: "96px",
                  position: "relative",
                  top: 30,
                }}
                alt="halfCircle"
              ></img>
              <Typography
                variant="H6"
                style={{ top: "-10px", position: "relative", color: "#EB5FE5" }}
              >
                E-simulation
              </Typography>
            </div>
            <div
              style={{
                width: "100%",
                height: 500,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                background: "#fdf5fd",
              }}
            >
              <div className={classes.conBox4} style={{ marginBottom: 20 }}>
                <div>
                  <div
                    className={classes.conSubBox6}
                    style={{
                      borderRadius: "20px 20px 0px 0px",
                      background: "#eb5fe5",
                    }}
                  >
                    <Typography variant="mbaContent" style={{ color: "#fff" }}>
                      간호창업 시뮬레이션
                    </Typography>
                  </div>
                  <div
                    className={classes.conSubBox6}
                    style={{ padding: "5px 0px", height: "80px" }}
                  >
                    <div className={classes.textlist_S}>
                      <span style={{ lineHeight: "20px" }}>
                        Two Scenario-based simulation cases
                      </span>
                      <br />
                      <li>Scenario 1 - 초기 간호 창업 준비기 사례</li>
                      <li>Scenario 2 - 간호창업 후 확장기 사례</li>
                    </div>
                  </div>
                </div>
                <div>
                  <div
                    className={classes.conSubBox6}
                    style={{
                      borderRadius: "20px 20px 0px 0px",
                      background: "#eb5fe5",
                    }}
                  >
                    <Typography variant="mbaContent" style={{ color: "#fff" }}>
                      경영 게임 전략 시뮬레이션 학습
                    </Typography>
                  </div>
                  <div
                    className={classes.conSubBox6}
                    style={{ height: "89px" }}
                  >
                    <div className={classes.textlist_S}>
                      <div style={{ padding: "5px 15px" }}>
                        <li>
                          주어진 사례에 가장 적절한 경영전략, 재무계획, 마케팅
                          분석을 수립 의사결정 대안은 경영전략, 재무계획, 마케팅
                          분석 각 영역별로 3개씩 총 9개가 제시 &#8667; 각
                          영역에서 1개씩 3개의 전략 조합을 선택
                        </li>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={classes.conBox}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={S_simul1}
                    alt="img_S_simul1"
                    style={{ marginRight: "10px" }}
                  ></img>
                  <img
                    src={S_simul2}
                    alt="img_S_simul2"
                    style={{ marginRight: "10px" }}
                  ></img>
                  {/* PINK 화살표 vector */}
                  <div
                    style={{
                      borderTop: "17px solid transparent",
                      borderRight: "0px solid transparent",
                      borderBottom: "17px solid transparent",
                      borderLeft: "13px solid #eb5fe5",
                      position: "relative",
                      marginRight: 7,
                    }}
                  />
                  {/* PINK 화살표 vector */}
                  <img
                    src={S_simul3}
                    alt="img_S_simul3"
                    style={{ marginRight: "10px" }}
                  ></img>
                  <img src={S_simul4} alt="img_S_simul4"></img>
                </div>
              </div>
            </div>
            {/* 슬라이드 */}
            <div className={classes.mobileSlider} style={{ marginBottom: 25 }}>
              <Typography variant="mbaContent" style={{ marginBottom: 10 }}>
                콘텐츠 구성
              </Typography>
              <MobileSliderMBA4 />
            </div>
          </div>
        </div>

        {/* (3-3) */}
        <div className={classes.container1}>
          <div className={classes.conBox3} style={{ alignItems: "center" }}>
            <div style={{ display: "contents" }}>
              <img
                src={half_circle}
                style={{
                  width: "193px",
                  height: "96px",
                  position: "relative",
                  top: 30,
                }}
                alt="halfCircle"
              ></img>
              <Typography
                variant="H6"
                style={{ top: "-10px", position: "relative", color: "#EB5FE5" }}
              >
                E-executive
              </Typography>
            </div>
            <div
              style={{
                width: "100%",
                height: 500,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                background: "#fdf5fd",
              }}
            >
              <div className={classes.conBox4} style={{ marginBottom: 20 }}>
                <div>
                  <div
                    className={classes.conSubBox6}
                    style={{
                      borderRadius: "20px 20px 0px 0px",
                      background: "#eb5fe5",
                    }}
                  >
                    <Typography variant="mbaContent" style={{ color: "#fff" }}>
                      모의 창업 계획서 작성
                    </Typography>
                  </div>
                  <div
                    className={classes.conSubBox6}
                    style={{ padding: "5px 0px", height: "115px" }}
                  >
                    <div className={classes.textlist1}>
                      <span style={{ lineHeight: "25px" }}>
                        간호창업 분야 선택
                      </span>
                      <br />
                      <li style={{ lineHeight: "25px" }}>
                        노인 간호 창업 분야
                      </li>
                      <li style={{ lineHeight: "25px" }}>
                        산모 및 영유아 간호 창업 분야
                      </li>
                      <li style={{ lineHeight: "25px" }}>간호교육 창업 분야</li>
                    </div>
                  </div>
                </div>
                <div>
                  <div
                    className={classes.conSubBox6}
                    style={{
                      borderRadius: "20px 20px 0px 0px",
                      background: "#eb5fe5",
                    }}
                  >
                    <Typography variant="mbaContent" style={{ color: "#fff" }}>
                      창업계획서 단계
                    </Typography>
                  </div>
                  <div className={classes.conSubBox6}>
                    <div className={classes.textlist_E}>
                      <div style={{ padding: "0px 10px" }}>
                        <li>
                          창업개요 : 업체 명명, 주요 사업 분야 및 사업 내용,
                          창업 배경 기술
                        </li>
                        <li>
                          전략수립 : 조직의 미션, 비전, 목표, 수행사업 작성,
                          SWOT 분석에 따른 SO 전략과 WT 전략 수립
                        </li>
                        <li>
                          마케팅 조사 : 창업지의 지역 및 인구 특성, 고객의
                          지불능력, 주요 경쟁사의 특성 분석
                        </li>
                        <li>
                          재무분석 : 자금조달 및 창업 5차년도까지 손익계획 작성
                        </li>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={classes.conBox}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={E_exec1}
                    alt="img_E_exec1"
                    style={{ marginRight: "10px", border: "1px solid #EB5FE5" }}
                  ></img>
                  <img
                    src={E_exec2}
                    alt="img_E_exec2"
                    style={{ marginRight: "10px", border: "1px solid #EB5FE5" }}
                  ></img>

                  {/* PINK 화살표 vector */}
                  <div
                    style={{
                      borderTop: "17px solid transparent",
                      borderRight: "0px solid transparent",
                      borderBottom: "17px solid transparent",
                      borderLeft: "13px solid #eb5fe5",
                      position: "relative",
                      marginRight: 7,
                    }}
                  />
                  {/* PINK 화살표 vector */}

                  <img
                    src={E_exec3}
                    alt="img_E_exec3"
                    style={{ marginRight: "10px", border: "1px solid #EB5FE5" }}
                  ></img>
                  <img
                    src={E_exec4}
                    alt="img_E_exec4"
                    style={{ border: "1px solid #EB5FE5" }}
                  ></img>
                </div>
              </div>
            </div>
            {/* 슬라이드 */}
            <div className={classes.mobileSlider}>
              <Typography variant="mbaContent" style={{ marginBottom: 10 }}>
                콘텐츠 구성
              </Typography>
              <MobileSliderMBA5 />
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <div style={{ display: "flex" }}>
        <MobileFooter />
      </div>
    </div>
  );
};

export default MbaContentPage;
